import { useFormik } from "formik";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Button from "../../components/Button";
import DataTableWrapper from "../../components/DataTableWrapper";
import PaddingContainer from "../../components/PaddingContainer";
import PageHeading from "../../components/PageHeading";
import Popover from "../../components/Popovers";
import SearchInput from "../../components/SearchInput";
import StatusIndicator from "../../components/StatusIndicator";
import TableValue from "../../components/TableValue";
import { AddCircleIcon, Pencil, Trash, ViewDetailIcon } from "../../constant";
import useDebounce from "../../customHooks/useDebounce";
import { formatNumberWithCommas } from "../../helpers";
import CourtManagementDetailModal from "../../modals/CourtManagementDetail";
import { setPageLink, setPageTitle } from "../../store/pageSlice";
import useApi from "../../useApi";
import classes from "./CourtManagement.module.css";
import AreYouSureModal from "../../modals/AreYouSureModal";
import EditCourtManagementModal from "../../modals/CourtManagement/EditCourtManagement";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TieredMenu } from "primereact/tieredmenu";
import Loader from "../../components/Loader";
import { Row, Col } from "react-bootstrap";
import NoDataFound from "../../components/NoDataFound";
// import AddOrEditCourtModal from "../../modals/Court/AddOrEditCourtModal";
// import DeleteModal from "../../components/DeleteModal";
// Add sorting fields enum
import CourtCard from "../../components/CourtCard";
const CourtSortFields = {
  CourtName: 1,
  CourtType: 2,
  Location: 3,
  Price: 4,
  Status: 5,
};

const initialValues = {
  locations: null,
  courtType: null,
  status: null,
};

export default function CourtManagement() {
  const { allPreLoadedApis } = useSelector((state) => state);
  const menu = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showCourtManagementModal, setShowCourtManagementModal] =
    useState(false);
  const [showEditPriceModal, setShowEditPriceModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [courts, setCourts] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows] = useState(10);
  const [search, setSearch] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [detailCourt, setDetailCourt] = useState(null);
  const debouncedValue = useDebounce(search);
  const { getAllCourts, addCourt, updateCourt, deleteCourt } = useApi();
  const [selectedItem, setSelectedItem] = useState(null);
  const { values, setFieldValue } = useFormik({
    initialValues,
  });

  const menuItems = [
    {
      label: "View Details",
      icon: <ViewDetailIcon className={classes.icon} />,
      command: () => {
        setDetailCourt(selectedItem);
        setShowCourtManagementModal(true);
      },
    },
    {
      label: "Edit Court",
      icon: <Pencil className={classes.icon} />,
      command: () => {
        navigate(`/court-management/edit-court/${selectedItem?.courtId}`, {
          state: selectedItem,
        });
      },
    },
    {
      label: "Delete Court",
      icon: <Trash className={classes.icon} />,
      command: () => {
        setDetailCourt(selectedItem);
        setShowDeleteModal(true);
      },
    },
  ];

  const columns = [
    {
      field: "courtName",
      header: "Court Name",
      sortable: true,
      sortField: CourtSortFields.CourtName,
      body: (rowData) => <TableValue top={rowData?.courtName} />,
    },
    {
      field: "courtSportTyp",
      header: "Court Type",
      sortable: true,
      sortField: CourtSortFields.CourtType,
      body: (rowData) => <TableValue top={rowData?.courtSportType} />,
    },
    {
      field: "location",
      header: "Location",
      sortable: true,
      sortField: CourtSortFields.Location,
      body: (rowData) => {
        let locationName;

        if (rowData?.location?.locationName) {
          locationName = rowData.location.locationName;
        }
        // }

        return (
          <TableValue
            top={rowData.location.locationName}
            down={rowData.location.locationAddress}
          />
        );
      },
    },
    // {
    //   field: "price",
    //   header: "Price Start From",
    //   sortable: true,
    //   sortField: CourtSortFields.Price,
    //   body: (rowData) => (
    //     <TableValue top={formatNumberWithCommas(rowData?.startingPrice)} />
    //   ),
    // },
    {
      field: "status",
      header: "Status",
      sortable: true,
      sortField: CourtSortFields.Status,
      body: (rowData) => (
        <StatusIndicator
          bookingStatus={rowData?.courtStatusId}
          activeLabel="Active"
          inactiveLabel="Inactive"
        />
      ),
    },
    {
      field: "actions",
      header: "Actions",
      body: (rowData) => {
        const items = [
          {
            label: "View Details",
            icon: <ViewDetailIcon className={classes.icon} />,
            command: () => {
              setDetailCourt(rowData);

              setShowCourtManagementModal(true);
            },
          },
          {
            label: "Edit Court  ",
            icon: <Pencil className={classes.icon} />,
            command: () => {
              navigate(`/court-management/edit-court/${rowData?.courtId}`, {
                state: rowData,
              });
            },
          },
          {
            label: "Delete Court",
            icon: <Trash className={classes.icon} />,
            command: () => {
              setDetailCourt(rowData);
              setShowDeleteModal(true);
            },
          },
        ];

        return <Popover items={items} />;
      },
    },
  ];

  const handlePageChange = (e) => {
    setFirst(e.first);
    getCourts({
      ...getCourtParams(),
      pageNumber: e.page + 1,
    });
  };

  const getCourtParams = () => {
    return {
      search: search,
      pageNumber: Math.floor(first / rows) + 1,
      pageSize: rows,
      locationId: values.locations || null,
      courtTypeId: values.courtType || null,
      isActive: values.status !== null ? values.status === 1 : null,
      isDesc: true,
      sortId: 0,
    };
  };

  const getCourts = async (params) => {
    setLoading(true);
    try {
      const result = await getAllCourts(params);
      if (result?.data?.headers?.error === 200) {
        setCourts(result?.data?.body?.items);
        setTotalCount(result?.data?.body?.totalItems);
      } else {
        toast.error(result?.data?.headers?.message);
      }
    } catch (error) {
      toast.error("Failed to fetch courts");
    }
    setLoading(false);
  };

  const handleDeleteCourt = async (courtData) => {
    setLoading(true);
    console.log("detailCourt ==>", detailCourt);
    const result = await updateCourt({
      courtId: detailCourt?.courtId,
      courtName: null,
      courtDescription: null,
      courtSportType: null,
      courtSlotDuration: null,
      courtStatusId: null,
      delete: true,
    });
    if (result?.data?.headers?.error === 200) {
      toast.success("Court Deleted successfully");
      setCourts((prev) =>
        prev.filter((court) => court?.courtId !== detailCourt?.courtId)
      );
    } else {
      toast.error(result?.data?.headers?.message);
    }
    setShowDeleteModal(false);
    setLoading(false);
  };

  const updateCourtStatus = async (params) => {
    console.log("params ==>", params)
    setLoading(true)
    const result = await updateCourt({
      courtId: params?.courtId,
      courtStatusId:params?.courtStatusId,
    });
    if (result?.data?.headers?.error === 200) {
      setCourts((prev) =>
        prev.map((court) =>
          court?.courtId === params?.courtId
            ? { ...court, courtStatusId: params?.courtStatusId }
            : court
        )
      );
      toast.success("Court Status Updated successfully");
      setLoading(false)
      return true
    } else {
      toast.error(result?.data?.headers?.message);
    }
    setLoading(false)
  };
  const handleAddNewCourt = () => {
    setSelectedCourt(null);
    navigate("/court-management/add-court");
  };

  useEffect(() => {
    dispatch(setPageTitle("Court Management"));
    dispatch(setPageLink(""));
  }, []);

  useEffect(() => {
    getCourts({
      id: null,
      search: debouncedValue,
      pageNumber: 1,
      pageSize: 12000,
      showInactive: false,
      showUpcoming: true,
    });
  }, [debouncedValue]);

  const [sortState, setSortState] = useState({
    field: null,
    order: null,
  });

  const handleSort = (event) => {
    setSortState({
      field: event.sortField,
      order: event.sortOrder,
    });

    getCourts({
      ...getCourtParams(),
      isDesc: event.sortOrder === -1,
      sortId: event.sortField || 0,
    });
  };

  // Dynamically created options for dropdowns
  const courtTypes =
    allPreLoadedApis?.courtTypes?.map((type) => ({
      label: type.typeName,
      value: type.typeId,
    })) || [];

  const locations =
    allPreLoadedApis?.locations?.map((location) => ({
      label: location.locationName,
      value: location.locationId,
    })) || [];

  const statusOptions = [
    { label: "Active", value: 1 },
    { label: "Inactive", value: 0 },
  ];

  const options = {
    courtType: courtTypes,
    locations: locations,
    status: statusOptions,
  };

  console.log("courts ==>", courts);
  return (
    <>
      <PaddingContainer>
        <div className={classes.titleContainer}>
          <div className={classes.tabsWrapper}>
            {/* <TabsContainer
              tabs={
                <>
                  {Object.keys(initialValues)?.map((filter) => (
                    <Dropdown
                      key={filter}
                      placeholder={filter === 'courtType' ? 'Court Type' : filter.charAt(0).toUpperCase() + filter.slice(1)}
                      className={clsx(classes.filterAction, classes.bgWhite)}
                      value={values[filter]}
                      onChange={(e) => {
                        setFieldValue(filter, e);
                      }}
                      options={options?.[filter] || []}
                    />
                  ))}
                </>
              }
            /> */}
          </div>
        </div>
        <ol className={classes.titleStrip}>
          <li>
            <PageHeading label="List of Courts" />
          </li>
          <li>
            <div className={classes.filterActions}>
              <div className={classes.searchContainer}>
                <SearchInput
                  placeholder={"Search by Court Name"}
                  onChange={setSearch}
                  value={search}
                />
              </div>
              <Button
                className={classes.addButton}
                label="Add Court"
                leftIcon={<AddCircleIcon />}
                onClick={handleAddNewCourt}
              />
            </div>
          </li>
        </ol>

        <>
          {loading ? (
            <Loader />
          ) : (
            <>
              {" "}
              {courts?.length > 0 ? (
                <Row>
                  {courts.map((court) => (
                    <Col md={6} lg={4} className={classes.mb20} key={court.courtId}>
                      <CourtCard
                        key={court.courtId}
                        court={court}
                        menu={
                          <>
                            <span
                              className={classes.menuIcon}
                              onClick={(e) => {
                                setSelectedItem(court);
                                menu.current.toggle(e);
                              }}
                            >
                              <BsThreeDotsVertical size={20} />
                            </span>
                            <TieredMenu
                              model={menuItems}
                              popup
                              ref={menu}
                              breakpoint="767px"
                            />
                          </>
                        }
                      />
                    </Col>
                  ))}
                </Row>
              ) : (
                <div className={classes.noDataFoundContainer}>
                  <NoDataFound title="No Courts Found" />
                </div>
              )}
            </>
          )}
        </>

        {/* <DataTableWrapper
          search={search}
          data={courts}
          columns={columns}
          loading={loading}
          totalRecords={totalCount}
          onPageChange={handlePageChange}
          first={first}
          rows={rows}
          onSort={handleSort}
          sortField={sortState.field}
          sortOrder={sortState.order}
        /> */}
      </PaddingContainer>

      {showCourtManagementModal && (
        <CourtManagementDetailModal
          onSubmit={updateCourtStatus}
          show={showCourtManagementModal}
          setShow={setShowCourtManagementModal}
          data={detailCourt}
        />
      )}
      {/* {showModal && (
        <AddOrEditCourtModal
          show={showModal}
          setShow={setShowModal}
          data={selectedCourt}
          onSubmit={handleAddOrUpdateCourt}
        />
      )}

      
      )} */}
      {showEditPriceModal && (
        <EditCourtManagementModal
          show={showEditPriceModal}
          setShow={setShowEditPriceModal}
          // data={selectedCourt}
          // onSubmit={handleAddOrUpdateCourt}
        />
      )}
      {showDeleteModal && (
        <AreYouSureModal
          title="Court"
          show={showDeleteModal}
          setShow={setShowDeleteModal}
          data={selectedCourt}
          onConfirm={handleDeleteCourt}
          loading={loading}
        />
      )}
    </>
  );
}
